import React, {Component} from 'react';
import './styles.css';
import CardHelper from '../../helpers';
import { isPS4Platform } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardTop extends Component {
  constructor(props) {
    super(props);
    this.state = { imageReady: !_isPS4 };
    this._imgRef = null;
    this._loadTimer = null;

    this._setImgRef = this._setImgRef.bind(this);

    // Cache
    this._cachedProgressBar = null;
    this._cachedBadge = null;
    this._prevBookmark = undefined;
    this._prevBadges = undefined;
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.cover !== nextProps.cover ||
      this.props.bookmark !== nextProps.bookmark ||
      this.props.badges !== nextProps.badges ||
      this.props.title !== nextProps.title ||
      this.props.classOutLineFocus !== nextProps.classOutLineFocus ||
      this.props.classNumberTop !== nextProps.classNumberTop ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    // Limpiar src de img para liberar memoria en PS4
    if (_isPS4 && this._imgRef) {
      this._imgRef.src = '';
    }
    this._imgRef = null;
    this._cachedProgressBar = null;
    this._cachedBadge = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setImgRef(el) {
    this._imgRef = el;
  }

  render() {
    const props = this.props;
    const bookmark = props.bookmark;
    const badges = props.badges;
    const classNumberTop = props.classNumberTop;
    const imageNumbersTop = props.imageNumbersTop;
    const hasNumberImg = imageNumbersTop.imgSrc !== undefined;
    const extraSpace = classNumberTop && classNumberTop.indexOf('numberTop-ten') !== -1;
    const imageReady = this.state.imageReady;
    const coverSrc = imageReady ? props.cover : '';

    if (bookmark !== this._prevBookmark) {
      this._prevBookmark = bookmark;
      this._cachedProgressBar = CardHelper.createProgressBar(bookmark);
    }

    if (badges !== this._prevBadges) {
      this._prevBadges = badges;
      this._cachedBadge = CardHelper.createBadge(badges, extraSpace);
    }

    return (
      <div className={'card card-top'}>
        <div className={'card-container'}>
          <div className={hasNumberImg ? 'preview-container' : 'preview-container-not-number'}>
            {hasNumberImg && (
              <div className={classNumberTop}>
                <img src={imageNumbersTop.imgSrc} alt="" />
              </div>
            )}
            <div className={hasNumberImg ? 'container-card-cover' : 'container-card-cover-not-number'}>
              <img
                ref={this._setImgRef}
                className={props.classOutLineFocus || ''}
                src={coverSrc}
                alt=""
              />
            </div>
            {this._cachedProgressBar}
            {this._cachedBadge}
          </div>
        </div>
        {bookmark > 0 && (
          <div className="card-labels-container">{CardHelper.createTitle(props.title)}</div>
        )}
      </div>
    );
  }
}

export default CardTop;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardTop/index.js